import { PravoNaGo } from './pravo-na-go';
import { BaseDataService, TabsContainerService, UserService } from 'yt-ng-framework';
import { ActivatedRoute } from '@angular/router';
import { Component, OnInit } from '@angular/core';
import { BaseTabsUpdateComponent } from 'yt-ng-framework';

@Component({
  selector: 'yt-pravo-na-go-tab-update',
  templateUrl: './pravo-na-go-tab-update.component.html',
})
export class PravoNaGoTabUpdateComponent extends BaseTabsUpdateComponent<PravoNaGo> implements OnInit {

  constructor(
    protected activatedRoute: ActivatedRoute,
    protected tabsContainerService: TabsContainerService<PravoNaGo>,
    protected baseDataService: BaseDataService,
    protected userService: UserService
  ) {
    super(activatedRoute, tabsContainerService, baseDataService, userService);
  }


  ngOnInit() {
    super.ngOnInit();
  }

}
